import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { toast } from "react-toastify";
import { getChildAssignments } from "../../api/parentDashboardApi";
import { submitAssignment } from "../../api/assignmentApi";

const statusSeverity = {
  graded: "success",
  submitted: "info",
  late: "warning",
  pending: "secondary",
};

const ChildAssignmentsTab = ({ child }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submittingFor, setSubmittingFor] = useState(null);
  const [submissionText, setSubmissionText] = useState("");

  const refresh = async () => {
    if (!child?.id) return;
    try {
      setLoading(true);
      const data = await getChildAssignments(child.id);
      if (data?.success) setItems(data.items || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [child?.id]);

  const handleSubmit = async () => {
    try {
      await submitAssignment(submittingFor.id, {
        studentId: child.id,
        submission_text: submissionText,
      });
      toast.success("Submitted");
      setSubmittingFor(null);
      setSubmissionText("");
      refresh();
    } catch (e) {
      toast.error("Failed to submit");
    }
  };

  return (
    <>
      <DataTable value={items} loading={loading} paginator rows={10} stripedRows emptyMessage="No assignments.">
        <Column field="title" header="Title" sortable />
        <Column field="subject.name" header="Subject" />
        <Column
          field="due_date"
          header="Due"
          body={(row) => (row.due_date ? new Date(row.due_date).toLocaleDateString() : "—")}
        />
        <Column
          header="Status"
          body={(row) => {
            const sub = row.submission;
            const status = sub?.status || "pending";
            return <Tag value={status} severity={statusSeverity[status] || "info"} />;
          }}
        />
        <Column
          header="Score"
          body={(row) =>
            row.submission?.score != null ? `${row.submission.score}/${row.max_score}` : "—"
          }
        />
        <Column
          header="Actions"
          body={(row) =>
            !row.submission && (
              <Button
                label="Submit"
                icon="pi pi-upload"
                className="p-button-sm"
                onClick={() => setSubmittingFor(row)}
              />
            )
          }
        />
      </DataTable>

      <Dialog
        header={`Submit: ${submittingFor?.title || ""}`}
        visible={!!submittingFor}
        onHide={() => setSubmittingFor(null)}
        style={{ width: "500px" }}
      >
        <div className="field">
          <label>Submission text</label>
          <InputTextarea
            value={submissionText}
            onChange={(e) => setSubmissionText(e.target.value)}
            rows={6}
            autoResize
            className="w-full"
          />
        </div>
        <div className="flex justify-content-end gap-2">
          <Button label="Cancel" className="p-button-text" onClick={() => setSubmittingFor(null)} />
          <Button label="Submit" icon="pi pi-upload" onClick={handleSubmit} />
        </div>
      </Dialog>
    </>
  );
};

export default ChildAssignmentsTab;
